export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginError: "login-error-message",
  logoutBtn: "logout-button",
  langSwitch: "lang-switch-button",
};

export const NAV = {
  dashboard: "nav-dashboard",
  companies: "nav-companies",
  workers: "nav-workers",
  deadlines: "nav-deadlines",
  documents: "nav-documents",
  certificates: "nav-certificates",
  courses: "nav-courses",
  users: "nav-users",
};

export const DASH = {
  root: "dashboard-root",
  cardCompanies: "dash-card-companies",
  cardWorkers: "dash-card-workers",
  cardCertificates: "dash-card-certificates",
  cardDeadlines: "dash-card-deadlines",
  upcomingList: "dash-upcoming-list",
};

export const COMPANIES = {
  root: "companies-root",
  createBtn: "create-company-button",
  form: "company-form",
  name: "company-name-input",
  vat: "company-vat-input",
  tax: "company-tax-input",
  email: "company-email-input",
  submit: "company-submit-button",
  row: (id) => `company-row-${id}`,
};

export const WORKERS = {
  root: "workers-root",
  createBtn: "create-worker-button",
  form: "worker-form",
  firstName: "worker-first-name",
  lastName: "worker-last-name",
  tax: "worker-tax",
  role: "worker-role",
  submit: "worker-submit",
  importBtn: "worker-import-button",
  templateBtn: "worker-template-button",
};

export const DEAD = {
  root: "deadlines-root",
  createBtn: "create-deadline-button",
  runReminders: "run-reminders-button",
  form: "deadline-form",
  title: "deadline-title-input",
  category: "deadline-category-select",
  due: "deadline-due-input",
  submit: "deadline-submit",
};

export const DOCS = {
  root: "documents-root",
  uploadBtn: "upload-document-button",
  dropzone: "documents-dropzone",
};

export const CERT = {
  root: "certificates-root",
  generateBtn: "generate-cert-button",
  form: "cert-form",
  courseTitle: "cert-course-title",
  submit: "cert-submit",
};
